import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";
import AppSelectList from "../../app/components/AppSelectList";
import AppTextInput from "../../app/components/AppTextInput";
import { Order, UpdateOrder } from "../../app/models/order";
import { useEffect } from "react";
import agent from "../../app/api/agent";
import { LoadingButton } from "@mui/lab";

interface Props {
    order: Order
    cancelEdit: () => void
   
}

const orderStatusList = ['Pending',
  'PaymentReceived',
  'PaymentFailed', 
  'Shipped',
  'Cancelled']

export default function EditOrder({order, cancelEdit}: Props) {

  const { control, reset, handleSubmit, formState: {isDirty, isSubmitting} } = useForm();

  useEffect(() => {
    if (order && !isDirty) {
      if (order.courierServiceProvider === null) {
         order.courierServiceProvider = ' '
      }
      if (order.trackingNumber === null) {
        order.trackingNumber = ' '
      }
      if (order.notes === null) {
      order.notes = ' '
      }
      reset(order)} 
      // we only want to reset the product only when the form is not dirty
   
    
}, [order, reset, isDirty])

async function handleOrderData(data: FieldValues) {
    try {
      
      let updateOrderInfo : UpdateOrder = {
        id: data.id,
        buyerEmail: data.buyerEmail,
        orderStatus: data.orderStatus,
        courierServiceProvider: data.courierServiceProvider,
        trackingNumber: data.trackingNumber,
        notes: data.notes
      }
      order.orderStatus = data.orderStatus
      order.courierServiceProvider = data.courierServiceProvider
      order.trackingNumber = data.trackingNumber
      order.notes = data.notes
      await agent.Admin.updateOrder(updateOrderInfo)
      // function to show new status
      // setOrder(order)
      cancelEdit()
    } catch (error) {
      console.log(error)
    }
}
    return (
      <Box component={Paper} sx={{p: 4, mb: 2}}>
          <Typography variant="h6" sx={{mb: 2}}>Edit Order</Typography>
          <form onSubmit={handleSubmit(handleOrderData)}>
              <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                      <AppSelectList control={control} items={orderStatusList} name='orderStatus' label='Order Status' testId="orderStatus"/>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                      <AppTextInput type='string' control={control} name='courierServiceProvider' label='Courier service provider' />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                      <AppTextInput type='string' control={control} name='trackingNumber' label='Tracking Number' />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                      <AppTextInput type='string' control={control} name='notes' label='Notes' />
                      <Typography variant="body2" sx={{ml: 2, mt: 1}}>Note: 
                    </Typography>
                    <Typography variant="body2" sx={{ml: 2, mt: 1}}> This note can only be seen by admin.
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={6} sm={6}>
                      <LoadingButton loading={isSubmitting}variant="contained" size='large' type='submit'>Save</LoadingButton>
                      
                  </Grid>
                  <Grid item xs={6} sm={6} container alignItems='flex-end' direction="column" justifyContent="flex-end">
                      <Button variant="contained" size='large' onClick={cancelEdit} sx={{bgcolor: 'primary.light'}}>Cancel</Button> 
                  </Grid>
                  
                  
              </Grid>
              
          </form>
      </Box>
    )
}